export default function actionsHeaderMenu(state = [], action) {
  switch (action.type) {
    case 'TOGGLE_ACTION_MENU':
      return {
        open: action.open,
      }
    default:
      return state;
  }
}
